module.exports = __webpack_public_path__ + "static/img/datavheader.2b6b43c1.png";